
































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import { isValidHttpUrl } from './service-for-algorithms/algorithms-1-is-valid-http-url'

import {
  DataTableFile,
  itemTypeFolder,
  itemTypeAccount,
  itemTypeTransaction,
  itemTypeDescriptionList,
  itemTypeGraph,
  itemTypeProductResource,
  itemTypeSettings
} from './service-for-data-structures/data-structures-1-file-system-data-structure'


import FolderItemView1DescriptionListView from './service-for-folder-item-view/folder-item-view-1-description-list-view.vue'
import FolderItemView2GraphView from './service-for-folder-item-view/folder-item-view-2-graph-view.vue'
import FolderItemView3AccountView from './service-for-folder-item-view/folder-item-view-3-account-view.vue'
import FolderItemView4ProductResourceView from './service-for-folder-item-view/folder-item-view-4-product-resource-view.vue'
import FolderItemView5SettingsView from './service-for-folder-item-view/folder-item-view-5-settings-view.vue'
import TransactionHelperComponents1MainPage from '../../html-components-type-2-application-specific/application-specific-type-2-pages/pages-type-6-transaction/service-for-transaction-helper-components/transaction-helper-components-1-main-page.vue'

import DigitalCurrency6AccountUserProfilePicture from '../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'


@Component({
  name: 'UserInterface2FolderDataTable',
  components: {
    FolderItemView1DescriptionListView,
    FolderItemView2GraphView,
    FolderItemView3AccountView,
    FolderItemView4ProductResourceView,
    FolderItemView5SettingsView,
    TransactionHelperComponents1MainPage,
    DigitalCurrency6AccountUserProfilePicture
  }
})
class UserInterface2FolderDataTable extends Vue {
  @Prop({ default: '' }) tableId?: string
  @Prop({ default: 'Search' }) dataTableSearchTextFieldLabel?: any
  @Prop({ default: () => [] }) folderActionButtonList?: any

  @Prop({ default: '' }) digitalCurrencyAccountId?: string

  // @Prop({ default: () => fileSystemForAccountDescription.fileSystemFolderOrFileList }) initialFileSystemDataStructureFolderOrFileList?: any
  @Prop({ default: () => { return {} } }) initialFile?: any

  searchText: string = ''

  customSearchText: string = ''
  isWaitingToSearch: boolean = false
  lastDateStartedTyping: number = 0
  customSearchDelayTime: number = 3 * 1000 // 3 seconds
  showSearchLoadingIcon: boolean = false

  page: number = 1
  pageCount: number = 0
  itemsPerPage: number = 10

  dataTableItemList: any[] = []

  rootFile: DataTableFile = new DataTableFile()

  currentFileItemIdList: string[] = []
  currentFileItemNameList: string[] = []
  currentFileItemIconImage: string[] = []

  currentSelectedItem: any = null

  itemTypeAccount: string = itemTypeAccount
  itemTypeTransaction: string = itemTypeTransaction
  itemTypeDescriptionList: string = itemTypeDescriptionList
  itemTypeGraph: string = itemTypeGraph
  itemTypeProductResource: string = itemTypeProductResource
  itemTypeSettings: string = itemTypeSettings

  isValidHttpUrl = isValidHttpUrl

  @Watch('initialFile', { deep: true }) async updateInitialFile () {
    Vue.set(this, 'rootFile', await this.initialFile)
    await this.updateCurrentSelectedFileFromInitialFolder()
  }

  @Watch('page') updatePage () {
    this.scrollToTop()
  }

  @Watch('customSearchText') updateCustomSearchText () {
    const onUpdateCustomSearchTextField = this.currentSelectedItem ? this.currentSelectedItem.itemData ? this.currentSelectedItem.itemData.onUpdateCustomSearchTextField !== undefined ? this.currentSelectedItem.itemData.onUpdateCustomSearchTextField : null : null : null
    if (!onUpdateCustomSearchTextField) {
      return
    }

    this.lastDateStartedTyping = (new Date()).getTime()

    if (this.isWaitingToSearch) {
      return
    }

    this.isWaitingToSearch = true
    this.checkIfUserHasStoppedTyping()

    setTimeout(() => {
      onUpdateCustomSearchTextField(this.customSearchText)
      this.isWaitingToSearch = false
    }, this.customSearchDelayTime)
  }

  checkIfUserHasStoppedTyping () {
    let dateSetIntervalId = setInterval(() => {
      const timeSinceLastTyping = (new Date()).getTime() - this.lastDateStartedTyping

      this.showSearchLoadingIcon = timeSinceLastTyping < this.customSearchDelayTime

      if (!this.showSearchLoadingIcon) {
        clearInterval(dateSetIntervalId)
      }
    }, 100)
  }

  get showSearchTextField () {
    const showSearchTextField = this.currentSelectedItem ? this.currentSelectedItem.itemData ? this.currentSelectedItem.itemData.showSearchTextField !== undefined ? this.currentSelectedItem.itemData.showSearchTextField : true : true : true
    const showCustomSearchTextField = this.currentSelectedItem ? this.currentSelectedItem.itemData ? this.currentSelectedItem.itemData.showCustomSearchTextField !== undefined ? this.currentSelectedItem.itemData.showCustomSearchTextField : false : false : false
    return showSearchTextField && !showCustomSearchTextField
  }

  get showCustomSearchTextField () {
    const showSearchTextField = this.currentSelectedItem ? this.currentSelectedItem.itemData ? this.currentSelectedItem.itemData.showSearchTextField !== undefined ? this.currentSelectedItem.itemData.showSearchTextField : true : true : true
    const showCustomSearchTextField = this.currentSelectedItem ? this.currentSelectedItem.itemData ? this.currentSelectedItem.itemData.showCustomSearchTextField !== undefined ? this.currentSelectedItem.itemData.showCustomSearchTextField : false : false : false
    return showSearchTextField && showCustomSearchTextField
  }

  get getDataTableHeaderList () {
    const fileSystemFolderOrFile = new DataTableFile()

    const headerList = []

    for (let propertyId in fileSystemFolderOrFile) {
      if (!fileSystemFolderOrFile.hasOwnProperty(propertyId)) {
        continue
      }

      headerList.push({ text: propertyId, value: propertyId })
    }

    headerList.push({ text: 'itemDataAsString', value: 'itemDataAsString' })

    return headerList
  }

  updateDataTableItemList () {
    if (!this.currentSelectedItem || !this.currentSelectedItem.fileVariableTable) {
      return []
    }
    const fileList = Object.keys(this.currentSelectedItem.fileVariableTable).map((fileItemId: string) => {
      const fileItem = this.currentSelectedItem.fileVariableTable[fileItemId]
      return {
        ...fileItem,
        // Useful for search with the data table default search
        itemDataAsString: JSON.stringify(fileItem)
      }
    })

    this.dataTableItemList = fileList
  }

  isCurrentItemFolder (): boolean {
    if (!this.currentSelectedItem) {
      return true
    }
    const isCurrentSelectedItemTypeFolder: boolean = this.currentSelectedItem.itemType === itemTypeFolder
    const isCurrentSelectedItemList: boolean = Array.isArray(this.currentSelectedItem)

    const isCurrentItemFolder = isCurrentSelectedItemTypeFolder || isCurrentSelectedItemList
    return isCurrentItemFolder
  }

  async mounted () {
    this.rootFile = await this.initialFile
    this.currentSelectedItem = this.rootFile
    this.updateDataTableItemList()
  }

  async openFolderOrFileItem (item: DataTableFile, _itemIndex: number) {
    this.currentFileItemIdList.push(item.itemId)
    this.currentFileItemNameList.push(item.itemName)
    this.currentFileItemIconImage.push(item.itemIconImageUrl)

    if (this.currentSelectedItem) {
      if (!this.currentSelectedItem.fileVariableTable) {
        this.currentSelectedItem.fileVariableTable = {}
      }
      if (!this.currentSelectedItem.fileVariableTable[item.itemId]) {
        this.currentSelectedItem.fileVariableTable[item.itemId] = item
      }
    }

    // this.rootFile = item
    this.currentSelectedItem = item

    this.scrollToTop()

    this.$emit('selectedItem', item)
    this.searchText = ''
    this.customSearchText = ''

    this.updateDataTableItemList()
    await this.updateCurrentSelectedFileFromInitialFolder()
  }

  scrollToTop () {
    const headerElement = this.$refs['folder-data-table-header'] as HTMLElement
    if (!headerElement) {
      return
    }
    const headerElementTopPosition = headerElement.getBoundingClientRect().top + window.scrollY
    window.scrollTo({ top: headerElementTopPosition - 200, behavior: 'smooth' })
  }

  async navigateBackToPreviousFileItem (deleteFileItem?: boolean) {

    if (this.currentFileItemIdList.length === 0) {
      return
    }

    // Remove the latest file from the index list
    const currentFileItemId = this.currentFileItemIdList.pop() || ''
    this.currentFileItemNameList.pop()
    this.currentFileItemIconImage.pop()

    // Navigate to the new file after the latest file
    // has been removed
    let rootFile: DataTableFile = await this.initialFile
    this.currentSelectedItem = null

    for (let i = 0; i < this.currentFileItemIdList.length; i++) {
      const fileItemId = this.currentFileItemIdList[i]
      let fileItem: any = rootFile

      if (rootFile.fileVariableTable) {
        fileItem = rootFile.fileVariableTable[fileItemId]
      }

      if (!fileItem) {
        break
      }

      rootFile = fileItem
    }

    // this.rootFile = rootFile
    this.currentSelectedItem = rootFile

    this.scrollToTop()

    this.$emit('selectedItem', this.currentSelectedItem)
    this.searchText = ''
    this.customSearchText = ''
    this.updateDataTableItemList()

    if (deleteFileItem && this.currentSelectedItem.fileVariableTable) {
      this.$emit('deleteItem', currentFileItemId)
    }
  }

  async updateCurrentSelectedFileFromInitialFolder () {
    let rootFile: DataTableFile = await this.initialFile

    for (let i = 0; i < this.currentFileItemIdList.length; i++) {
      const fileItemId = this.currentFileItemIdList[i]
      let fileItem: DataTableFile = rootFile

      if (rootFile.fileVariableTable) {
        fileItem = rootFile.fileVariableTable[fileItemId]
      }

      if (!fileItem) {
        this.currentFileItemIdList.splice(i, this.currentFileItemIdList.length)
        this.currentFileItemNameList.splice(i, this.currentFileItemNameList.length)
        this.currentFileItemIconImage.splice(i, this.currentFileItemIconImage.length)
        break
      }

      if (fileItem.itemName) {
        Vue.set(this.currentFileItemNameList, i, fileItem.itemName)
      }

      if (fileItem.itemIconImageUrl) {
        Vue.set(this.currentFileItemIconImage, i, fileItem.itemIconImageUrl)
      }

      rootFile = fileItem
    }

    // Vue.set(this, 'rootFile', rootFile)
    Vue.set(this, 'currentSelectedItem', rootFile)
  }

  onUpdateGraphViewDataTablePageData (pageData: any) {
    this.$emit('graphViewDataTablePageData', pageData)
  }
}


export default UserInterface2FolderDataTable


